import vsComponent from './vsPagination';

export default Vue => {
  Vue.component(vsComponent.name, vsComponent);
};
